import React from "react"
import Layout from "../components/layout"
import BlockContent from "../components/blockContent"
import styles from "./page.module.scss"
import PageHeader from "../components/PageHeader"
import Body from "../components/body"
import LinkRow from "../components/LinkRow"
import { graphql } from "gatsby"
import Breadcrumb from "../components/Breadcrumb"
import SEO from "../components/seo"

const Page = (props) => {
  const {
    title,
    introduction,
    mainImage,
    ogImage,
    subPages,
    mainPageRef,
    _rawContent: content,
    isHomePage,
  } = props.data.sanityPage

  return (
    <Layout className={styles.pageWrapper} isHomePage={isHomePage}>
      <SEO
        title={title}
        description={introduction}
        ogImage={ogImage && ogImage.asset?.images?.fallback?.src}
      />
      <Breadcrumb parentPage={mainPageRef} currentPageTitle={title} />
      <PageHeader image={mainImage} title={title} introduction={introduction} />
      <LinkRow links={subPages} path={props.path} />
      <Body>
        <BlockContent blocks={content} />
      </Body>
    </Layout>
  )
}

export const query = graphql`
  query Page($slug: String, $id: String) {
    sanityPage(slug: { current: { eq: $slug } }) {
      title
      introduction
      mainPageRef {
        slug {
          current
        }
        title
      }
      subPages {
        slug {
          current
        }
        title
      }
      mainImage {
        ...ImageWithPreview
      }
      ogImage: mainImage {
        ...ImageWithPreview
      }
      _rawContent(resolveReferences: { maxDepth: 9 })
    }
    allSanityPage(filter: { mainPageRef: { _id: { eq: $id } } }) {
      edges {
        node {
          slug {
            current
          }
          title
        }
      }
    }
  }
`

export default Page
